import { sitePhrasing } from "../../../../Language/languageHandler";
import {
    updateCart,
} from "../../../../Redux/Shopping/shoppingSlice";
import { useAppDispatch } from "../../../../Redux/store";
import { AddressInputFieldGroup } from "../../../FormFields/AddressFieldGroup/AddressInputFieldGroup";
import {
    ArrayEntryFieldType,
    ArrayFieldInput,
} from "../../../FormFields/ArrayField/ArrayFieldInput";
import CheckboxInputField from "../../../FormFields/CheckboxInputField/CheckboxInputField";
import RadioInputField from "../../../FormFields/RadioInputField/RadioInputField";
import SelectFieldInput from "../../../FormFields/SelectInputField/SelectInputField";
import TextInputField from "../../../FormFields/TextInputField/TextInputField";
import ImportantMessage from "../../../ImportantMessage/ImportantMessage";
import { ContactInfoFields } from "../ContactInfoFields";
import { ADDRESS_FIELD_NAMES, electronicSignatureSublabelGeneral, iAgreeText, laborLawPosterAgreementText, mayBeContactedAgreementText, stateTransactionAcknowledgmentText, yesOrNoValues } from "../PurchaseConstants";
import { forcedRegistered, forcedStatePrincipal } from "../PurchaseFormHelpers";
import { AnnualReferenceNumberInstructions, TermsAndConditionAcceptText } from "../SharedPurchaseFieldComponents";
import { VirginiaAnnualReportTerms } from "./StateSpecificAnnualTerms";

export default function VirginiaAnnualReportFields(props: {
    errors: any;
    touched: any;
    values: any;
    selectedProducts: any;
    setFieldValue: any;
}) {
    const { errors, touched, values, selectedProducts, setFieldValue } = props;

    const dispatch = useAppDispatch();

    const updateShoppingCart = (product: string) => {
        dispatch(updateCart(product));
    };

    return (
        <>

            <ContactInfoFields
                values={values}
                touched={touched}
                errors={errors}
                setFieldValue={setFieldValue}
            />

            <TextInputField
                mask={sitePhrasing.referenceMask}
                fieldName={"referenceNumber"}
                fieldLabel={"Reference Number"}
                fieldSubLabel={undefined}
                customFieldInstructions={() => (<AnnualReferenceNumberInstructions />)}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Reference Number"}
                maskGuide={sitePhrasing.referenceMaskGuide}
            />

            <TextInputField
                fieldName={"businessName"}
                fieldLabel={"Complete Business Name"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Complete Business Name"}
            />

            <h3>Do you need to change any of the following information?</h3>

            {values.annualReport.typeOfEntity === "llc" && (
                <>
                    <RadioInputField
                        fieldName={"annualReport.informationChange.principalAddress.changed"}
                        fieldLabel={"Principal Address?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                        onChange={(e: any) => {
                            if (e.target.value === "no") {
                                if (selectedProducts["principalAddressChanges"]) {
                                    updateShoppingCart("principalAddressChanges");
                                }
                            } else {
                                if (!selectedProducts["principalAddressChanges"]) {
                                    updateShoppingCart("principalAddressChanges");
                                }
                            }
                            setFieldValue("annualReport.informationChange.principalAddress.changed", e.target.value);
                        }}
                    />
                    {values.annualReport.informationChange.principalAddress.changed === "yes" && (
                        <>
                            <ImportantMessage>
                                <b>IMPORTANT NOTICE:</b>{" "}<u>Changing your principal address requires an additional $25 fee and has been added to your total cost.</u>
                            </ImportantMessage>

                            <AddressInputFieldGroup
                                fieldName={
                                    "annualReport.informationChange.principalAddress.newAddress"
                                }
                                errors={errors}
                                touched={touched}
                            />
                        </>
                    )}


                    <RadioInputField
                        fieldName={"annualReport.informationChange.registeredAgent.agentChange"}
                        fieldLabel={"Registered Agent?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                        onChange={(e: any) => {
                            if (e.target.value === "no") {
                                if (selectedProducts["registeredAgentChanges"]) {
                                    updateShoppingCart("registeredAgentChanges");
                                }
                            } else {
                                if (!selectedProducts["registeredAgentChanges"]) {
                                    updateShoppingCart("registeredAgentChanges");
                                }
                            }
                            setFieldValue("annualReport.informationChange.registeredAgent.agentChange", e.target.value);
                        }}
                    />
                    {values.annualReport.informationChange.registeredAgent.agentChange === "yes" && (
                        <>
                            <ImportantMessage>
                                <b>IMPORTANT NOTICE:</b>{" "}<u>Changing your registered agent requires an additional $25 fee and has been added to your total cost.</u>
                            </ImportantMessage>

                            <RadioInputField
                                fieldName={"annualReport.informationChange.registeredAgent.agentType"}
                                fieldLabel={"Is the new registered agent an individual or an organization?"}
                                errors={errors}
                                required={true}
                                touched={touched}
                                options={[
                                    { value: "individual", label: "Individual" },
                                    { value: "organization", label: "Organization" },
                                ]}
                            />

                            {values.annualReport.informationChange.registeredAgent.agentType === "individual" && (
                                <>
                                    <SelectFieldInput
                                        fieldName={"annualReport.informationChange.registeredAgent.raCapacity"}
                                        fieldLabel={"Registered Agent Capacity"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"- Select Capacity -"}
                                        options={[
                                            { value: "Director of the Corporation", label: "Director of the Corporation" },
                                            { value: "Member of the Virginia State Bar", label: "Member of the Virginia State Bar" },
                                            { value: "Officer of the Corporation", label: "Officer of the Corporation" },
                                        ]}
                                    />
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.firstName"}
                                        fieldLabel={"First Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"First Name"}
                                    />
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.lastName"}
                                        fieldLabel={"Last Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"Last Name"}
                                    />
                                </>
                            )}

                            {values.annualReport.informationChange.registeredAgent.agentType === "organization" && (
                                <>
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.businessName"}
                                        fieldLabel={"Business Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"Business Name"}
                                    />
                                </>
                            )}

                            {(values.annualReport.informationChange.registeredAgent.agentType === "organization" ||
                                values.annualReport.informationChange.registeredAgent.agentType === "individual") && (
                                    <AddressInputFieldGroup
                                        fieldName={"annualReport.informationChange.registeredAgent.newAddress"}
                                        errors={errors}
                                        touched={touched}
                                        fieldMessages={{
                                            state: forcedRegistered[sitePhrasing.state] ? `Your registered agent must be located in ${sitePhrasing.state}.` : ``,
                                        }}
                                        disableFields={{
                                            state: forcedRegistered[sitePhrasing.state] ? true : false,
                                        }}
                                    />
                                )}
                        </>
                    )}


                </>
            )}

            {(values.annualReport.typeOfEntity === "stockCorporation" || values.annualReport.typeOfEntity === "nonStockCorporation") && (
                <>
                    <RadioInputField
                        fieldName={
                            "annualReport.informationChange.emailAddress.emailAddressChange"
                        }
                        fieldLabel={"E-Mail address?"}
                        // fieldLabel={"Principal Business E-Mail address?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                    />
                    {values.annualReport.informationChange.emailAddress.emailAddressChange === "yes" && (
                        <TextInputField
                            fieldName={
                                "annualReport.informationChange.emailAddress.newEmailAddress"
                            }
                            fieldLabel={"E-mail address"}
                            errors={errors}
                            touched={touched}
                            required={true}
                            placeholder={"Enter your new complete E-mail address"}
                        />
                    )}

                    {/* change contactNumber.changeNumber */}
                    <RadioInputField
                        fieldName={
                            "annualReport.informationChange.contactNumber.changeNumber"
                        }
                        fieldLabel={"Contact Number?"}
                        // fieldLabel={"Principal Business Contact Number?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                    />
                    {values.annualReport.informationChange.contactNumber.changeNumber === "yes" && (
                        <>
                            <TextInputField
                                mask={["(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                                fieldName={'annualReport.informationChange.contactNumber.newContactNumber'}
                                fieldLabel={'New Contact Number'}
                                errors={errors}
                                touched={touched}
                                required={true}
                                placeholder={'New Contact Number'}
                            />
                        </>
                    )}


                    <RadioInputField
                        fieldName={"annualReport.informationChange.principalAddress.changed"}
                        fieldLabel={"Principal Office Address?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                    />
                    {values.annualReport.informationChange.principalAddress.changed === "yes" && (
                        <>
                            <AddressInputFieldGroup
                                fieldName={
                                    "annualReport.informationChange.principalAddress.newAddress"
                                }
                                errors={errors}
                                touched={touched}
                            />
                        </>
                    )}

                    {/* ENTITY OFFICER FIELD SET */}
                    <RadioInputField
                        fieldName={"annualReport.informationChange.officer.officerChange"}
                        fieldLabel={"Entity Officers?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                    />
                    {values.annualReport.informationChange.officer.officerChange === "yes" && (
                        <>

                            <RadioInputField
                                fieldName={"annualReport.informationChange.officer.removingOfficers"}
                                fieldLabel={`Are you removing any Entity Officers?`}
                                errors={errors}
                                required={true}
                                touched={touched}
                                options={yesOrNoValues}
                            />
                            {values.annualReport.informationChange.officer.removingOfficers === "yes" && (
                                <>
                                    <ArrayFieldInput
                                        fieldName={"annualReport.informationChange.officer.removedOfficers"}
                                        values={values.annualReport.informationChange.officer.removedOfficers}
                                        // blankEntryFn={() => blankOfficerFn(values.annualReport.typeOfEntity)}
                                        blankEntryFn={() => ({
                                            name: "",
                                        })}
                                        // fields={officerFields(values.annualReport.typeOfEntity)}
                                        fields={[
                                            {
                                                fieldType: "text",
                                                fieldName: "name",
                                                fieldLabel: "Name",
                                                placeholder: "Name",
                                                required: true,
                                            }
                                        ]}
                                        touched={touched}
                                        errors={errors}
                                        removeText={"- Click to remove entry"}
                                        addText={"+ Click to add an entry"}
                                        setFieldValue={setFieldValue}
                                    />
                                </>
                            )}

                            <RadioInputField
                                fieldName={"annualReport.informationChange.officer.addingOfficers"}
                                fieldLabel={`Are you adding any Entity Officers?`}
                                errors={errors}
                                required={true}
                                touched={touched}
                                options={yesOrNoValues}
                            />
                            {values.annualReport.informationChange.officer.addingOfficers === "yes" && (
                                <ArrayFieldInput
                                    fieldName={"annualReport.informationChange.officer.addedOfficers"}
                                    values={values.annualReport.informationChange.officer.addedOfficers}
                                    blankEntryFn={() => blankOfficerFn(values.annualReport.typeOfEntity)}
                                    fields={officerFields(values.annualReport.typeOfEntity)}
                                    touched={touched}
                                    errors={errors}
                                    removeText={"- Click to remove entry"}
                                    addText={"+ Click to add an entry"}
                                    setFieldValue={setFieldValue}
                                />
                            )}
                        </>
                    )}

                    <RadioInputField
                        fieldName={"annualReport.informationChange.registeredAgent.agentChange"}
                        fieldLabel={"Registered Agent?"}
                        errors={errors}
                        required={true}
                        touched={touched}
                        options={yesOrNoValues}
                        onChange={(e: any) => {
                            if (e.target.value === "no") {
                                if (selectedProducts["registeredAgentChanges"]) {
                                    updateShoppingCart("registeredAgentChanges");
                                }
                            } else {
                                if (!selectedProducts["registeredAgentChanges"]) {
                                    updateShoppingCart("registeredAgentChanges");
                                }
                            }
                            setFieldValue("annualReport.informationChange.registeredAgent.agentChange", e.target.value);
                        }}
                    />
                    {values.annualReport.informationChange.registeredAgent.agentChange === "yes" && (
                        <>
                            <ImportantMessage>
                                <b>IMPORTANT NOTICE:</b>{" "}<u>Changing your registered agent requires an additional $25 fee and has been added to your total cost.</u>
                            </ImportantMessage>

                            <RadioInputField
                                fieldName={"annualReport.informationChange.registeredAgent.agentType"}
                                fieldLabel={"Is the new registered agent an individual or an organization?"}
                                errors={errors}
                                required={true}
                                touched={touched}
                                options={[
                                    { value: "individual", label: "Individual" },
                                    { value: "organization", label: "Organization" },
                                ]}
                            />

                            {values.annualReport.informationChange.registeredAgent.agentType === "individual" && (
                                <>
                                    <SelectFieldInput
                                        fieldName={"annualReport.informationChange.registeredAgent.raCapacity"}
                                        fieldLabel={"Registered Agent Capacity"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"- Select Capacity -"}
                                        options={[
                                            { value: "Director of the Corporation", label: "Director of the Corporation" },
                                            { value: "Member of the Virginia State Bar", label: "Member of the Virginia State Bar" },
                                            { value: "Officer of the Corporation", label: "Officer of the Corporation" },
                                        ]}
                                    />
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.firstName"}
                                        fieldLabel={"First Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"First Name"}
                                    />
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.lastName"}
                                        fieldLabel={"Last Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"Last Name"}
                                    />
                                </>
                            )}

                            {values.annualReport.informationChange.registeredAgent.agentType === "organization" && (
                                <>
                                    <TextInputField
                                        fieldName={"annualReport.informationChange.registeredAgent.agentEntityName"}
                                        fieldLabel={"Agent Entity Name"}
                                        errors={errors}
                                        touched={touched}
                                        required={true}
                                        placeholder={"Agent Entity Name"}
                                    />
                                </>
                            )}

                            {(values.annualReport.informationChange.registeredAgent.agentType === "individual") && (
                                <AddressInputFieldGroup
                                    fieldName={"annualReport.informationChange.registeredAgent.newAddress"}
                                    errors={errors}
                                    touched={touched}
                                    fieldMessages={{
                                        state: forcedRegistered[sitePhrasing.state] ? `Your registered agent must be located in ${sitePhrasing.state}.` : ``,
                                    }}
                                    disableFields={{
                                        state: forcedRegistered[sitePhrasing.state] ? true : false,
                                    }}
                                />
                            )}
                        </>
                    )}

                </>
            )}


            <div className="terms-and-conditions-container">
                <VirginiaAnnualReportTerms />
                <br /><br />
                {iAgreeText}
                <br /><br />
                {selectedProducts["laborLawPoster"] && (
                    <>
                        {laborLawPosterAgreementText}
                        <br /><br />
                    </>
                )}
                {stateTransactionAcknowledgmentText}
                <br /><br />
                <TermsAndConditionAcceptText />
            </div>

            <CheckboxInputField
                fieldName={'termAndConditionAgree'}
                fieldLabel={`I've read and accept the terms and conditions.`}
                touched={touched}
                errors={errors}
                onChange={(e: any) => {
                    const checkedVal = e.target.checked ? true : false;
                    setFieldValue('generalAgree', checkedVal)
                    setFieldValue('iAgree', checkedVal)
                    setFieldValue('annualReport.annualAgree', checkedVal)
                    setFieldValue('annualReport.tellingTruth', checkedVal)
                    setTimeout(() => {
                        setFieldValue('termAndConditionAgree', checkedVal)
                    }, 0)

                }}
            />

            <TextInputField
                fieldName={"annualReport.electronicSignature"}
                fieldLabel={"Name of Individual Signing - Electronic Signature"}
                fieldSubLabel={electronicSignatureSublabelGeneral}
                fieldSubLabelCustomClass={'red-text'}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Electronic Signature"}
                customClass={"signature-font"}
            />

            <TextInputField
                fieldName={"annualReport.title"}
                fieldLabel={"Title"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Title"}
            />

            <TextInputField
                fieldName={"annualReport.firstName"}
                fieldLabel={"First Name"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"First Name"}
            />

            <TextInputField
                fieldName={"annualReport.lastName"}
                fieldLabel={"Last Name"}
                errors={errors}
                touched={touched}
                required={true}
                placeholder={"Last Name"}
            />

        </>
    );
}


export const blankOfficerFn = (typeOfCorp: string) => ({
    name: "",
    director: "",
    titles: [],
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
});

export const officerFields = (typeOfCorp: string): ArrayEntryFieldType[] => {

    return [
        {
            fieldType: "text",
            fieldName: "name",
            fieldLabel: "Name",
            placeholder: "Name",
            required: true,
        },

        {
            fieldType: "radio",
            fieldName: "director",
            fieldLabel: "Director",
            required: true,
            options: [
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
            ],
        },

        {
            fieldType: "checkboxArray",
            fieldName: "titles",
            fieldLabel: "Officer Title",
            placeholder: "Officer Title",
            required: true,
            options: [
                { value: "President", label: "President" },
                { value: "Vice President", label: "Vice President" },
                { value: "Secretary", label: "Secretary" },
                { value: "Treasurer", label: "Treasurer" },
                { value: "Officer", label: "Officer" },
                { value: "Other", label: "Other" },
            ],
            extra: {
                customClass: "virginia-officer-titles",
            }
        },
        {
            fieldType: 'text',
            fieldName: 'address',
            fieldLabel: ADDRESS_FIELD_NAMES.address,
            placeholder: ADDRESS_FIELD_NAMES.address,
            required: true,
        },
        {
            fieldType: 'text',
            fieldName: 'address2',
            fieldLabel: ADDRESS_FIELD_NAMES.address2,
            placeholder: ADDRESS_FIELD_NAMES.address2,
        },
        {
            fieldType: 'text',
            fieldName: 'city',
            fieldLabel: ADDRESS_FIELD_NAMES.city,
            placeholder: ADDRESS_FIELD_NAMES.city,
            required: true,
        },
        {
            fieldType: 'text',
            fieldName: 'state',
            fieldLabel: ADDRESS_FIELD_NAMES.state,
            placeholder: ADDRESS_FIELD_NAMES.state,
            required: true,
        },
        {
            fieldType: 'text',
            fieldName: 'zip',
            fieldLabel: ADDRESS_FIELD_NAMES.zip,
            placeholder: ADDRESS_FIELD_NAMES.zip,
            required: true,
        },
    ]
};